import { Radio, Flex, Group, Button, useMantineTheme } from "@mantine/core";
import { useModals } from "@mantine/modals";
import { useState } from "react";
import {
  PaymentMethodType,
  SignedAgreementStatus,
  useGetClientPaymentMethodsManyQuery,
  useUpdateSignedAgreementMutation,
} from "src/generated/graphql";

interface IPaymentProps {
  signedAgreementId: string;
  clientId: string;
  selectedPaymentMethod?: string;
  onRefetch: () => void;
}
const Payment = ({
  signedAgreementId,
  clientId,
  selectedPaymentMethod,
  onRefetch,
}: IPaymentProps) => {
  const modals = useModals();
  const theme = useMantineTheme();
  const [value, setValue] = useState(selectedPaymentMethod);

  const { data, loading } = useGetClientPaymentMethodsManyQuery({
    variables: {
      clientId: clientId || "",
    },
    fetchPolicy: "network-only",
  });

  const [updateAgreement, {}] = useUpdateSignedAgreementMutation({
    onCompleted: () => {
      onRefetch();
      modals.closeAll();
    },
  });
  const updateSignedAgreementPaymentMethod = () => {
    value &&
      updateAgreement({
        variables: {
          id: signedAgreementId,
          data: {
            status: SignedAgreementStatus.Active,
            paymentMethod: {
              id: value,
            },
          },
        },
      });
  };

  return (
    <>
      <Radio.Group
        value={value}
        onChange={setValue}
        name="Payment Methods"
        description="Select Payment Method"
        withAsterisk
        styles={{
          root: {
            "&:focus-within": {
              label: {
                transform: "translateY(0px)",
              },
            },
          },
        }}
      >
        <Flex direction={"column"} mt="xs">
          {data?.clientPaymentMethodsMany?.map((card) => {
            return (
              <Radio
                key={card.id}
                mx={10}
                my={10}
                width={"100%"}
                value={card.id}
                sx={{
                  ".mantine-Radio-label": {
                    color: theme.colors.secondaryTextColor[6],
                  },
                }}
                label={`${card.name} - ${
                  card.type === PaymentMethodType.Card
                    ? card.merchant
                    : "Bank Account"
                } ending in ${card.mask?.substring(card.mask.length - 4)}`}
              />
            );
          })}
        </Flex>
      </Radio.Group>

      <Button
        size={"xs"}
        mt={20}
        disabled={!value || loading}
        onClick={() =>
          value && signedAgreementId && updateSignedAgreementPaymentMethod()
        }
      >
        Save Payment Method
      </Button>
    </>
  );
};

export default Payment;
